import { useEffect } from "react";
import { KeyPressListener } from "../classes/KeyPressListener";

export function useKeyPress(key, callback) {
  useEffect(() => {
    const listener = new KeyPressListener(key, () => {
      callback();
    });
    return () => {
      listener.unbind();
    };
  });
}
